var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3724 0.311544L22.7573 9.77418C23.1224 10.1069 23.243 10.6195 23.0649 11.0802C22.8864 11.5408 22.452 11.8384 21.958 11.8384H20.2991V21.3193C20.2991 21.6953 19.9943 22 19.6184 22H13.9265C13.5506 22 13.2458 21.6952 13.2458 21.3193V15.5628H9.90038V21.3193C9.90038 21.6952 9.59559 22 9.21969 22H3.5275C3.15161 22 2.84682 21.6952 2.84682 21.3193V11.8384H1.18818C0.6942 11.8384 0.259761 11.5408 0.0813293 11.0802C-0.0970574 10.6196 0.0235548 10.1069 0.388692 9.77422L10.7736 0.311499C11.2292 -0.103818 11.9166 -0.103863 12.3724 0.311544ZM15.55 1.35867H20.1213C20.4972 1.35867 20.8019 1.66341 20.8019 2.03931V6.13416L15.55 1.35867Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0522deebff25f12c9aa7b63b6fc10c86.svg";
export { ForwardRef as ReactComponent };